import React from 'react'
import { Loader } from '../../assets/icons'

interface IProps {
    placeholder: string
    secondary?: boolean
    type?: 'submit' | 'button'
    onClick?: () => void
    isLoading?: boolean
}

export default function ButtonForm(props: IProps): React.ReactElement {
    return (
        <button
            onClick={props.onClick}
            type={props.type}
            disabled={props.isLoading}
            className={props.secondary ? 'button-form-secondary' : 'button-form'}
        >
            {!props.isLoading || props.secondary ? props.placeholder : <Loader fill="#fff" />}
        </button>
    )
}
